import Swal from "sweetalert2";

export default {
  install(Vue) {
    Vue.prototype.$alert = {
      fire(text, title = "", type) {
        Swal.fire({
          title: title,
          html: text,
          icon: type,
        });
      },
      success(text, title = "") {
        Swal.fire({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          customClass: {
            popup: "p-3",
            content: "mx-3 my-auto",
          },
          timer: 3000,
          timerProgressBar: true,
          title: title,
          html: text,
          icon: "success",
          onOpen: (toast) => {
            toast.addEventListener("mouseenter", Swal.stopTimer);
            toast.addEventListener("mouseleave", Swal.resumeTimer);
          },
        });
      },

      confirm(text, successCallback = null, title = "") {
        Swal.fire({
          title,
          text,
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-primary btn-sm",
            cancelButton: "btn btn-outline-primary btn-sm",
          },
          confirmButtonText: "Да",
          cancelButtonText: "Нет",
        }).then((result) => {
          if (result.value && successCallback !== null) {
            successCallback();
          }
        });
      },
      error(text, title = "") {
        this.fire(text, title, "error");
      },
      warning(text, title = "") {
        this.fire(text, title, "warning");
      },
      info(text, title = "") {
        this.fire(text, title, "info");
      },
    };
  },
};
